import client from './client'

const apiBasePath = '/api/account/'

export default {
  top: () => client.get(apiBasePath + 'top'),
  change: entryForm => client.post(apiBasePath + 'change', entryForm),
  getAccount: () => client.post(apiBasePath + 'getAccount')
}
